import React from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import colors from 'src/utils/colors';
import type { SxProps, Theme } from '@mui/material/styles';

type CloseIconButtonProps = {
  onClick: () => void;
  iconFontSize?: 'inherit' | 'large' | 'medium' | 'small';
  sx?: SxProps<Theme>;
};

const CloseIconButton: React.FC<CloseIconButtonProps> = ({ onClick, iconFontSize = 'large', sx }) => {
  const baseSx: SxProps<Theme> = {
    color: colors.darkBlue,
    backgroundColor: 'transparent',
    padding: '8px',
    '&:hover': {
      backgroundColor: `${colors.darkerGrey}14`
    }
  };

  return (
    <IconButton onClick={onClick} sx={[baseSx, sx]}>
      <Close fontSize={iconFontSize} />
    </IconButton>
  );
};

export default CloseIconButton;
